import script from "./LessonLabCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LessonLabCard.vue?vue&type=script&setup=true&lang=ts"

import "./LessonLabCard.vue?vue&type=style&index=0&id=746c833b&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4241219202/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-746c833b"]])

export default __exports__